import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Home } from "./pages/Home";
import { CaseStudyIAClinical } from "./pages/CaseStudyIAClinical";

function App() {
  const [lang, setLang] = useState("es");

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home lang={lang} onLang={setLang} />} />
        <Route path="/proyectos/iaclinical" element={<CaseStudyIAClinical lang={lang} onLang={setLang} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
